<template>
  <div class="search-form">
    <b-row>
      <b-col cols="12">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="$l('table_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_custBizTeamSetStatus') || '有效状态'"
            >
              <el-checkbox-group v-model="form.listCustBizTeamSetStatus">
                <el-checkbox label="Y">
                  {{ $l('form_label_custBizTeamSetStatus_Y') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_label_custBizTeamSetStatus_N') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_custStatus') || '客户状态'">
              <el-checkbox-group v-model="form.listCustStatus">
                <el-checkbox label="W">
                  {{ $l('form_label_custStatus_W') || '待审批' }}
                </el-checkbox>
                <el-checkbox label="P">
                  {{ $l('form_label_custStatus_P') || '审批中' }}
                </el-checkbox>
                <el-checkbox label="B">
                  {{ $l('form_label_custStatus_B') || '驳回' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_custStatus_Y') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_label_custStatus_N') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_custName') || '负责客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelectByStatus"
                :body="{ dictType: ['W', 'B', 'P', 'Y'] }"
                :placeholder="$l('form_placeholder_cust') || '请选择客户'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_userName') || '团队成员'">
              <dict-select
                v-model="form.listUserCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_user') || '请选择团队成员'"
                clearable
                filterable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bizTeamRoles') || '业务团队角色'"
            >
              <dict-select
                v-model="form.listBizTeamRoles"
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'bizTeamRoles' }"
                :placeholder="
                  $l('form_placeholder_bizTeamRoles') || '请选择业务团队角色'
                "
                clearable
                filterable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  listCustBizTeamSetStatus: ['Y'],
  listCustStatus: ['W', 'Y', 'P', 'B'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
